import { render } from "./leaderboard-national-icon.vue?vue&type=template&id=217b644a&ts=true"
import script from "./leaderboard-national-icon.vue?vue&type=script&lang=ts"
export * from "./leaderboard-national-icon.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__